import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useTranslation } from "../../../../utilities/i18n";
import {
  Card,
  FlatActionList,
  Text,
  Page,
  Stack,
} from "@towersystems/roam-common-native";
import Location from "../../../../utilities/data/model/Location";
import { Q } from "@nozbe/watermelondb";
import { useGenericFilterListScreenProvider } from "../../../../components/GenericFilterListScreen";
import React from "react";
import { StockOrderFilterValues } from "../../types";
import { useListFilterContext } from "../../../../utilities/list-filter/use-list-filter-context";
import {
  StockOrderFilterRootParamList,
  StockOrderRootParamList,
} from "../../../../types";
import { StackScreenProps } from "@react-navigation/stack";

export type StockOrderFilterScreenProps = StackScreenProps<
  StockOrderRootParamList & StockOrderFilterRootParamList,
  "StockOrderFilterScreen"
>;

export const StockOrderFilterScreen = ({
  navigation,
}: StockOrderFilterScreenProps) => {
  const db = useDatabase();
  const { t } = useTranslation("stockorder");
  const { setScreenOptions } = useGenericFilterListScreenProvider();
  const context = useListFilterContext<StockOrderFilterValues>();

  const handleOnLocationFilterSelect = React.useCallback(async () => {
    const locations = await db.collections
      .get<Location>("locations")
      .query(Q.and(Q.where("deleted_at", Q.eq(null))));

    setScreenOptions({
      title: t("action.filter_sale_location.label"),
      options: locations.map((location) => ({
        id: location.id,
        name: location.name,
      })),
      initialSelectedOptions: context.getFilterValues("locationId") ?? [],
      onSelectOption: (ids) => context.setFilterValue("locationId", ids),
    });

    navigation.navigate("GenericFilterListScreen");
  }, []);

  const { locationId = [], productId = [] } = context.watch();

  return (
    <Page
      title={t("select_stockorder_filter_title")}
      secondaryTitle={t("select_stockorder_filter_subtitle")}
    >
      <Stack vertical>
        <Card>
          <FlatActionList
            items={[
              {
                key: "locationId",
                title: t("action.filter_location.label"),
                subTitle: t("action.filter_location.description"),
                onPress: handleOnLocationFilterSelect,
                isAction: (locationId.length || 0) > 0,
                componentRight: (icon) => {
                  return (locationId.length || 0) > 0 ? (
                    <Stack centerVertical>
                      <Text color="action">{locationId.length} selected</Text>
                      {icon}
                    </Stack>
                  ) : (
                    icon
                  );
                },
              },

              {
                key: "productId",
                title: t("common:actions.filter_product.label"),
                subTitle: t("common:actions.filter_product.description"),
                onPress: () =>
                  navigation.navigate("SelectableProductsFilterScreen"),
                isAction: (productId?.length || 0) > 0,
                componentRight: (icon) => {
                  return (productId?.length || 0) > 0 ? (
                    <Stack centerVertical>
                      <Text color="action">{productId?.length} selected</Text>
                      {icon}
                    </Stack>
                  ) : (
                    icon
                  );
                },
              },
            ]}
          />
        </Card>
      </Stack>
    </Page>
  );
};
